module.exports = __webpack_public_path__ + "static/assets/b497b53fa113def606efa11334d786ff.svg";